import React, { useState } from 'react'
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Tooltip from '@material-ui/core/Tooltip'
import {
  mdiMenu,
  mdiViewGridPlusOutline,
  mdiWhiteBalanceSunny,
  mdiMagnify,
  mdiCursorPointer,
  mdiRuler,
  mdiChevronDown,
  mdiAxisArrow,
  mdiVideo,
  mdiCamera,
  mdiShareVariant,
  mdiFileDocument,
  mdiFileCad,
  mdiRefresh,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiHistory,
  mdiClipboardListOutline,
  mdiInboxArrowDown,
  mdiViewColumn,
} from '@mdi/js'
import { t } from '../../i18n'

/**
 * Top bar mínima OHIF (cromo).
 */
function OhifTopBar({
  planLabel,
  toolActive,
  isFullscreen,
  showMenu = true,
  anyOpen = false,
  onToggleMenu,
  onToggleDrawer,
  onLayout,
  onToggleFullscreen,
  toolExecute,
  onAdvancedAction,
  showRelatedStudies = false,
  onRelatedStudies,
  showWorklist = false,
  onWorklist,
  compareMode = false,
  compareModeEnabled = false,
  onToggleCompareMode,
  showLocalStudies = false,
  onLocalStudies,
  bell,
}) {
  const iconColor = 'var(--ohif-icon, #cbd5e1)'
  const [advEl, setAdvEl] = useState(null)

  const toolBtn = (title, tool, path) => {
    const active = toolActive === tool
    return (
      <Tooltip title={title} key={tool}>
        <IconButton
          size="small"
          className={active ? 'udv-ohif-btn is-active' : 'udv-ohif-btn'}
          onClick={() => toolExecute && toolExecute(tool)}
          aria-label={title}
          disabled={!anyOpen && tool !== 'notool'}
        >
          <Icon path={path} size={0.82} color={active ? 'var(--ohif-accent)' : iconColor} />
        </IconButton>
      </Tooltip>
    )
  }

  const runAdv = (action) => {
    setAdvEl(null)
    if (onAdvancedAction) onAdvancedAction(action)
  }

  return (
    <header className="udv-ohif-topbar">
      <div className="udv-ohif-topbar-left">
        {showMenu ? (
          <Tooltip title="Menú">
            <IconButton
              size="small"
              className="udv-ohif-btn"
              onClick={onToggleMenu}
              aria-label="Menú"
            >
              <Icon path={mdiMenu} size={0.88} color={iconColor} />
            </IconButton>
          </Tooltip>
        ) : null}
        <Tooltip title="Series">
          <IconButton
            size="small"
            className="udv-ohif-btn"
            onClick={onToggleDrawer}
            aria-label="Series"
          >
            <Icon path={mdiChevronDown} size={0.88} color="var(--ohif-accent)" style={{ transform: 'rotate(90deg)' }} />
          </IconButton>
        </Tooltip>
        <div className="udv-ohif-brand">
          <span className="udv-ohif-brand-mark">UDV</span>
          {planLabel ? (
            <span className="udv-ohif-brand-mode">{planLabel}</span>
          ) : null}
        </div>
      </div>

      <div className="udv-ohif-topbar-center">
        {toolBtn('WW/WC', 'Wwwc', mdiWhiteBalanceSunny)}
        {toolBtn('Zoom', 'Zoom', mdiMagnify)}
        {toolBtn('Pan', 'Pan', mdiCursorPointer)}
        {toolBtn('Length', 'Length', mdiRuler)}
      </div>

      <div className="udv-ohif-topbar-right">
        {bell}
        {showRelatedStudies ? (
          <Tooltip title={t('relatedStudies.menuTooltip')}>
            <IconButton
              size="small"
              className="udv-ohif-btn"
              onClick={() => onRelatedStudies && onRelatedStudies()}
              aria-label={t('relatedStudies.menu')}
            >
              <Icon path={mdiHistory} size={0.82} color={iconColor} />
            </IconButton>
          </Tooltip>
        ) : null}
        {showWorklist ? (
          <Tooltip title={t('worklist.menuTooltip')}>
            <IconButton
              size="small"
              className="udv-ohif-btn"
              onClick={() => onWorklist && onWorklist()}
              aria-label={t('worklist.menu')}
            >
              <Icon path={mdiClipboardListOutline} size={0.82} color={iconColor} />
            </IconButton>
          </Tooltip>
        ) : null}
        <Tooltip
          title={
            compareMode
              ? t('relatedStudies.compareModeOff')
              : compareModeEnabled
                ? t('relatedStudies.compareModeOn')
                : t('relatedStudies.compareModeDisabled')
          }
        >
          <span>
            <IconButton
              size="small"
              className={
                compareMode ? 'udv-ohif-btn is-active' : 'udv-ohif-btn'
              }
              onClick={() => onToggleCompareMode && onToggleCompareMode()}
              aria-label={t('relatedStudies.compareMode')}
              disabled={!compareMode && !compareModeEnabled}
            >
              <Icon
                path={mdiViewColumn}
                size={0.82}
                color={compareMode ? 'var(--ohif-accent)' : iconColor}
              />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Layout">
          <IconButton
            size="small"
            className="udv-ohif-btn"
            onClick={onLayout}
            aria-label="Layout"
          >
            <Icon path={mdiViewGridPlusOutline} size={0.82} color={iconColor} />
          </IconButton>
        </Tooltip>
        <Tooltip title={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}>
          <IconButton
            size="small"
            className="udv-ohif-btn"
            onClick={onToggleFullscreen}
            aria-label="Fullscreen"
          >
            <Icon
              path={isFullscreen ? mdiFullscreenExit : mdiFullscreen}
              size={0.82}
              color={iconColor}
            />
          </IconButton>
        </Tooltip>
        <button
          type="button"
          className="udv-ohif-adv-btn"
          onClick={(e) => setAdvEl(e.currentTarget)}
          aria-haspopup="true"
        >
          Avanzadas
          <Icon path={mdiChevronDown} size={0.65} color="currentColor" />
        </button>
        <Menu
          anchorEl={advEl}
          open={Boolean(advEl)}
          onClose={() => setAdvEl(null)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={() => runAdv('mpr')}>
            <ListItemIcon>
              <Icon path={mdiAxisArrow} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="MPR" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('cine')}>
            <ListItemIcon>
              <Icon path={mdiVideo} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="Cine" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('capture')}>
            <ListItemIcon>
              <Icon path={mdiCamera} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="Capturar" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('share')}>
            <ListItemIcon>
              <Icon path={mdiShareVariant} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="Compartir" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('attachPdf')} disabled={!anyOpen}>
            <ListItemIcon>
              <Icon path={mdiFileCad} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="Adjuntar PDF / informe" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('header')}>
            <ListItemIcon>
              <Icon path={mdiFileDocument} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="DICOM Header" />
          </MenuItem>
          <MenuItem onClick={() => runAdv('reset')}>
            <ListItemIcon>
              <Icon path={mdiRefresh} size={0.85} />
            </ListItemIcon>
            <ListItemText primary="Reset imagen" />
          </MenuItem>
          {showLocalStudies ? (
            <MenuItem onClick={() => runAdv('localStudies')}>
              <ListItemIcon>
                <Icon path={mdiInboxArrowDown} size={0.85} />
              </ListItemIcon>
              <ListItemText primary={t('menu.localStudies')} />
            </MenuItem>
          ) : null}
          {showRelatedStudies ? (
            <MenuItem onClick={() => runAdv('relatedStudies')}>
              <ListItemIcon>
                <Icon path={mdiHistory} size={0.85} />
              </ListItemIcon>
              <ListItemText primary={t('menu.relatedStudies')} />
            </MenuItem>
          ) : null}
          {showWorklist ? (
            <MenuItem onClick={() => runAdv('worklist')}>
              <ListItemIcon>
                <Icon path={mdiClipboardListOutline} size={0.85} />
              </ListItemIcon>
              <ListItemText primary={t('menu.worklist')} />
            </MenuItem>
          ) : null}
        </Menu>
      </div>
    </header>
  )
}

export default OhifTopBar
